import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../auxiliares/auxiliares.module';
import { MapaRoutingModule } from './mapa.routing.module';
import { FlotanteComponent } from './flotante/flotante.component';
import { IslaComponent } from './isla/isla.component';
import { MapaPrincipalComponent } from './mapa/mapa-principal.component';
import { MapaMapboxComponent } from './mapa-mapbox/mapa-mapbox.component';

@NgModule({
  declarations: [
    FlotanteComponent,
    IslaComponent,
    MapaMapboxComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    MapaRoutingModule,
    MapaPrincipalComponent,
  ],
})
export class MapaModule {}
